enum RoutesPath {
  // Common routes
  Properties = "/properties",
  PropertyDetails = "/properties/:id",
  PropertyMediaFolder = "/properties/:id/folder/:folderId",
  PropertyPreview = "/properties/:id/preview",
  PropertyPublicPreview = "/properties/:id/public-preview",
  PropertyAgentPreview = "/properties/:id/agent-preview",
  PropertyDirectPreview = "/properties/:id/direct-preview",
  Organizations = "/organizations",
  OrganizationDetails = "/organizations/:id",
  Amenities = "/amenities",
  Brokers = "/brokers",
  BrokersDetails = "/brokers/:id",
  Seekers = "/seekers",
  SeekersDetails = "/seekers/:id",
  ExternalSales = "/external-sales",
  ExternalSalesUsers = "/external-sales/:id",
  Management = "/management",
  APIManagement = "/api",
  APIManagementCompanyDetails = "/api/companies/:id",
  APIManagementPluginUserDetails = "/api/plugin-users/:id",
  SignIn = "/auth/sign-in",
  SignInMFA = "/auth/sign-in/mfa",
  SignUp = "/auth/sign-up",
  ForgotPassword = "/auth/forgot-password",
  ResetPassword = "/auth/resetPassword",
  Account = "/account",
  MarketAreas = "/market-areas",
  // public urls
  TermConditions = "/term-conditions",
  PrivacyPolicy = "/privacy-policy",
}

export { RoutesPath };
